import { API } from "@/main";
import { Store } from "vuex";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  FETCH_ALL_NETWORK_RULES_TEMPLATES({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      API.networkRules.getAll(
        data.type,
        data.value,
        data.queryParams,
        result => {
          resolve(result.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  FETCH_NETWORK_RULES_TEMPLATE({ commit }, templateUUID) {
    return new Promise((resolve, reject) => {
      API.networkRules.getByID(
        templateUUID,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  CREATE_NETWORK_RULES_TEMPLATE({ commit }, newTemplate) {
    return new Promise((resolve, reject) => {
      API.networkRules.create(
        newTemplate,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  EDIT_NETWORK_RULES_TEMPLATE({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.networkRules.edit(
        data.uuid,
        data.updatedFields,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  DELETE_NETWORK_RULES_TEMPLATE({ commit }, templateUUID) {
    return new Promise((resolve, reject) => {
      API.networkRules.delete(
        templateUUID,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/Management/NetworkRules/networkRules.js